/**
 * Manages the sticky behavior of the header by toggling CSS classes based on scroll position.
 * It adds `header--top` when at the top of the viewport and `header--pinned` after
 * scrolling past the hero element.
 *
 * This module is designed to work with the Lenis smooth scroll library.
 *
 * @param {import('lenis').default} lenisInstance The initialized Lenis instance.
 */
export function initializeStickyHeader(lenisInstance) {
    if (!lenisInstance) {
        console.error('Sticky Header: Lenis instance not provided.');
        return;
    }

    const header = document.getElementById('header');
    const hero = document.querySelector('.hero');
    const body = document.body;

    if (!header) {
        console.error('Sticky Header: Header element with id="header" not found.');
        return;
    }

    // Determine the scroll threshold to "pin" the header.
    // If a hero element exists, we pin after scrolling past it.
    // Otherwise, we pin after scrolling a small amount (e.g., 1px).
    const pinThreshold = hero ? hero.offsetHeight : 1;

    /**
     * Handles the scroll event to update header classes.
     * @param {{ scroll: number }} e - The scroll event data from Lenis.
     */
    const handleScroll = (e) => {
        const scrollY = e.scroll;

        // Add 'header--top' class only when scroll position is at the very top.
        header.classList.toggle('header--top', scrollY <= 1);

        // Add 'header--pinned' class when the user has scrolled past the threshold.
        header.classList.toggle('header--pinned', scrollY > pinThreshold);
    };

    // Set the initial state of the header when the script loads.
    // This ensures the correct classes are applied on page load, not just on scroll.
    handleScroll({ scroll: lenisInstance.scroll });

    // Listen for scroll events from the Lenis instance.
    lenisInstance.on('scroll', handleScroll);
}

